import { LifeBuoy } from 'lucide-react';
import { Outlet } from 'react-router-dom';

import { Logo } from '@/components/branding/Logo';
import { useAppExperienceMode } from '@/features/shared/hooks/useAppExperienceMode';
import { appExperienceModeClassName } from '@/features/shared/lib/appExperienceMode';
import { cn } from '@/utils/cn';

export function AuthLayout() {
  const experienceMode = useAppExperienceMode();
  const isMobilePwa = experienceMode === 'mobile-pwa';

  return (
    <div
      className={cn(
        'relative min-h-dvh overflow-x-hidden bg-slate-100 text-slate-900 transition-colors dark:bg-slate-950 dark:text-slate-50',
        appExperienceModeClassName(experienceMode)
      )}
    >
      {!isMobilePwa ? (
        <>
          <div className="dark:from-brand-950/40 pointer-events-none absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-brand-100/60 via-sky-50/50 to-transparent dark:via-slate-950 dark:to-transparent" />
          <div className="pointer-events-none absolute left-1/2 top-[-8rem] h-72 w-72 -translate-x-1/2 rounded-full bg-brand-200/30 blur-3xl dark:bg-brand-500/10" />
        </>
      ) : null}

      <div className="app-auth-shell relative mx-auto flex min-h-dvh w-full max-w-5xl flex-col pt-[max(1rem,env(safe-area-inset-top))] sm:px-6 sm:pb-8 sm:pt-8">
        <div className={cn('mx-auto w-full max-w-md', isMobilePwa ? 'app-auth-brand-compact' : '')}>
          <div className="app-auth-card mb-6 border border-white/70 bg-white/80 shadow-[0_20px_60px_-40px_rgba(15,23,42,0.35)] backdrop-blur dark:border-slate-800/80 dark:bg-slate-900/80 sm:mb-8 sm:px-6 sm:py-5">
            <div className="flex items-center justify-center">
              <Logo variant="vertical" className="w-full max-w-[220px]" />
            </div>
            <div className="mt-4 space-y-1 text-center">
              <p className="text-xs font-semibold uppercase tracking-[0.28em] text-brand-700 dark:text-brand-300">
                Secure access
              </p>
              <p className="text-sm text-slate-600 dark:text-slate-300">
                Clinical workflows with lower-friction sign-in for care teams.
              </p>
            </div>
          </div>
        </div>

        <div className="mx-auto flex w-full max-w-md flex-1 flex-col justify-center">
          <div className="app-auth-card bg-white/96 dark:bg-slate-900/96 border border-slate-200/80 shadow-[0_20px_70px_-45px_rgba(15,23,42,0.45)] backdrop-blur dark:border-slate-800 sm:p-7">
            <Outlet />
          </div>
        </div>

        <div
          className={cn(
            'mx-auto mt-6 flex w-full max-w-md items-center justify-end gap-3 px-1 pb-[max(0.25rem,env(safe-area-inset-bottom))] text-xs text-slate-500 dark:text-slate-400',
            isMobilePwa ? 'hidden' : ''
          )}
        >
          <button
            type="button"
            className="inline-flex shrink-0 items-center gap-1.5 rounded-full px-3 py-2 font-medium text-slate-500 transition-colors hover:bg-white/70 hover:text-brand-700 dark:text-slate-400 dark:hover:bg-slate-900/70 dark:hover:text-brand-300"
          >
            <LifeBuoy size={15} />
            Support
          </button>
        </div>
      </div>
    </div>
  );
}
